// extracted by mini-css-extract-plugin
export var productImage = "_no-1";
export var viewLink = "_no-2";
export var wishlistItem = "_no-0";